import { createContext } from 'react'

export const PORTALS = {
  DROPDOWN: 'dropdown-root',
  TOOLTIP: 'tooltip-root',
  CALENDAR: 'calendar-root',
} as const

export type PortalKey = keyof typeof PORTALS

export function getPortalRoot(key: PortalKey): HTMLElement {
  const id = PORTALS[key]
  const element = document.getElementById(id)
  return element ?? document.body
}

export function findPortalRoot(key: PortalKey): HTMLElement | null {
  return document.getElementById(PORTALS[key])
}

export const PopupLayerContext = createContext(false)
